import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ConfigService {
    terminalDownloadURL: string = environment.terminalDownloadURL;
    assetsPath: string = environment.assetsPath;
    //basePath: string = environment.apiURI;
    basePath: string = "https://axxess-backend-v1.s3-us-west-2.amazonaws.com/PROD/";
    apiURI: string = environment.apiURI + 'api/v1/';
    apiURIv2: string = environment.apiURI + 'api/v2/';
    adminLogin: string = 'public/admin/login';
    adminLogout: string = 'oauth/logout';
    merchantRegistration: string = 'admin/merchant/register';
    categoriesList: string = 'public/settings/categories';
    allCategoriesList: string = 'admin/settings/category/list';
    offersList: string = 'merchant/offer/list';
    cardEditions: string = 'merchant/offer/cardeditions';
    productsList: string = 'admin/product/list';
    salesRepresentatives: string = 'public/settings/sales';
    interests: string = 'public/settings/interests';
    cuisines: string = 'public/settings/cuisines';
    getAllMerchants: string = 'admin/merchants';
    getAllMerchantsMinimumData: string = 'admin/merchants/list';
    neighbourhoods: string = 'public/settings/neighbourhood';
    refreshToken: string = this.apiURI + 'public/refreshtoken';
    getDashboard: string = this.apiURI + 'admin/statistics';
    getTimeZone: string = this.apiURI + 'public/settings/default-timezone';

    fundraiserOrders: string = this.apiURI + 'public/fundraiser/order';
    adminFundraisers: string = this.apiURI + 'admin/fundraisers';
    adminFundraiserOrders: string = this.apiURI + 'admin/fundraiser/orders';

    constructor() {}
    timeToKeepStates: number =  60000;//10 minutes

    exportLocations: string = 'merchant/locations/export';

    getFundraiserOrdersAll() {
        return this.fundraiserOrders + '/all';
    }

    exportFundraiserOrdersList() {
        return this.fundraiserOrders + '/all';    
    }

    updateFundraiserOrder(orderId) {
        return this.adminFundraiserOrders + '/update/' + orderId;
    }

    fundraisersSummaryReport: string = this.adminFundraisers + '/report/summary';
    importFundraiserFile: string = this.adminFundraisers + '/import';
    createFundraiser: string = this.adminFundraisers;
    fundraiserList: string = this.adminFundraisers + '/list';
    updateFundraiser(fundraiserId) {
        return this.adminFundraisers + '/' + fundraiserId;
    }
    getFundraiserMembershipsReport(fundraiserId) {
        return this.adminFundraisers + '/' + fundraiserId + '/report';
    }
    getFundraiserRedemptionsReport(fundraiserId) {
        return this.adminFundraisers + '/' + fundraiserId + '/report/redemption';
    }

    getFundraiserOrder(fundraiserOrderId) {
        return this.adminFundraiserOrders + '/' + fundraiserOrderId;
    }



    fundraisorslist:string=this.apiURI + 'public/fundraiser/fundraisers';

    // getFundraisersAll() {
    //     return this.adminFundraisers ;
    // }

    // exportFundraisersList() {
    //     return this.fundraisers + '/fundraisers';
    // }






    getMerchantOffers(merchantId) {
        return 'merchant/' + merchantId + '/offer/list';
    }

    addNewOffer(merchantId) {
        return 'merchant/' + merchantId + '/offer';
    }

    addOfferPeriods(offerId) {
        return 'merchant/offer/' + offerId + '/period';
    }

    getOfferPeriods(offerId) {
        return 'merchant/offer/' + offerId + '/period/list';
    }

    deleteFrozenPeriod(offerId, periodId) {
        return `merchant/offer/${offerId}/period/${periodId}`;
    }

    updateOffer(merchantId, id) {
        return 'merchant/' + merchantId + '/offer/' + id;
    }

    changeOfferStatus(merchantId, id) {
        return 'merchant/' + merchantId + '/offer/' + id + '/status'
    }

    getOffer(merchantId, id) {
        return 'merchant/' + merchantId + '/offer/' + id;
    }

    getMerchantDetails(id) {
        return 'merchant/details?bid=' + id;
    }

    getCategoriesPeriods(id) {
        return `location/${id}/category/period/list`;
    }

    loginAsMerchant(id) {
        return 'admin/merchant/impersonate/' + id;
    }

    deleteMerchantLogo(id) {
        return 'merchant/logo?bid=' + id;
    }

    addMerchantImages() {
        return 'merchant/images';
    }

    deleteMerchantImage(id) {
        return 'merchant/images/' + id;
    }

    deleteMerchantWorksheet(id) {
        return 'merchant/worksheet?bid=' + id;
    }

    updateMerchantLogo() {
        return 'merchant/logo';
    }

    updateMerchantWorksheet() {
        return 'merchant/worksheet';
    }

    updateMerchantStatus(id) {
        return 'admin/merchants/' + id + '/enabled';
    }
    setDefaultAlbumImage(id, bidId) {
        return `merchant/images/${id}/default?bid=${bidId}`;
    }
    /// Locations part

    getMerchantLocations(status, id) {
        if (undefined === status) {
            return 'merchant/locations?bid=' + id;
        } else {
            return 'merchant/locations?active=' + status + '&bid=' + id;
        }
    }

    getCatAndSubCat(includeSubs) {
        return `member/browse/categories?includeSubs=${includeSubs}&includeImages=false`;
    }

    orderCategories() {
        return 'admin/settings/category/order';
    }

    getMerchantLocation(id, bid) {
        return 'merchant/location/' + id + '?bid=' + bid;
    }

    createMerchantLocation() {
        return 'merchant/location/create';
    }

    updateMerchantLocation(id) {
        return 'merchant/location/' + id + '/update';
    }

    deletePeriod(locationId, periodId) {
        return `location/${locationId}/category/period/${periodId}`;
    }

    categoryPeriod(locationId, forced) {
        return `location/${locationId}/category/period?forced=${forced}`;
    }

    enableDisableLocation(locationId) {
        return 'merchant/location/' + locationId + '/enabled';
    }
    ///Locations Employee part
    exportLocationEmployee(lid, bid){
        return this.apiURI  + 'merchant/location/' + lid + '/employees/export?bid=' + bid;
    }
    createLocationEmployee(lid) {
        return 'merchant/location/' + lid + '/employee/create' ;
    }

    updateLocationEmployee(lid, eid) {
        return 'merchant/location/' + lid + '/employee/' + eid + '/update' ;
    }

    enableDisableEmployee(lid, eid) {
        return 'merchant/location/' + lid + '/employee/' + eid + '/enabled' ;
    }
    /// end of Location

    addNewEmployee() {
        return 'admin/account/create' ;
    }

    changeEmployeeStatus(id) {
        return 'admin/account/' + id + '/enable';
    }

    getEmployee(id) {
        return 'admin/account/' + id;
    }

    updateEmployee(id) {
        return 'admin/account/' + id + '/update';
    }

    changeEmployeePassword:string = 'admin/account/change-password';
    emoloyeesList:string = 'admin/employees';
    updateMerchantDetails: string = 'merchant/details';

    terminals: string = this.apiURI + 'admin/terminals';

    // Product part
    getProductCardsList() {
        return this.apiURI + 'admin/product/cards/list';
    }

    getProductCardEditions() {
        return this.apiURI + 'admin/product/cards/editions';
    }

    updateProductCardVip(id) {
        return this.apiURI + 'admin/product/cards/' + id + '/vip';
    }

    updateProductCardStatus(id) {
        return this.apiURI + 'admin/product/cards/' + id + '/status';
    }

    exportProductCardsList() {
        return this.apiURI + 'admin/product/cards/export'
    }

    exportMerchantOffers: string = this.apiURI + 'merchant/offer/list/export';
    exportOrders: string = this.apiURI + 'admin/order/export';
    exportMembers: string = this.apiURI + 'admin/members/export';

    exportMembersEmails: string = this.apiURI + 'admin/members/emails/export';

    exportRedemptions: string = this.apiURI + 'transaction/list/export';

    beneficiariesSummaryReport: string = this.apiURI + 'admin/beneficiaries/report/summary';

    getProductsList() {
        return this.apiURI + 'admin/product/list';
    }

    updateProductStatus(id) {
        return this.apiURI + 'admin/product/' + id + '/status';
    }

    deleteThumbnail(id) {
        return this.apiURI + 'admin/product/' + id + '/thumbnailImage';
    }

    deleteDetailedLogo(id) {
        return this.apiURI + 'admin/product/' + id + '/detailImage';
    }

    getProductCategories: string = this.apiURI + 'admin/product/categories';
    getProductCrossSale: string = this.apiURI + 'admin/product/crosssale';
    createProduct: string = this.apiURI +  'admin/product';
    getProduct(id) {
        return this.apiURI + 'admin/product/' + + id;
    }

    updateProduct(id) {
        return this.apiURI + 'admin/product/' + id;
    }
    toggleProductPin(id) {
        return this.apiURI + 'admin/product/' + id + '/pinned';
    }
    productcardgeneration : string = this.apiURI + 'admin/product/cardgeneration';
    getProductGeneratedCardsList : string = this.apiURI + 'admin/product/cardgeneration/list';
    exportGeneratedCardBundle(id) {
        return this.apiURI + 'admin/product/cardgeneration/' + id + '/exportcards';
    }

    // branded images
    createBrandedImages(productId) {
        return this.apiURI + 'admin/product/' + productId + '/branded-images';
    }

    updateBrandedImages(productId, imageId) {
        return this.apiURI + 'admin/product/' + productId + '/branded-images/' + imageId;
    }

    deleteBrandedImages(productId, imageId) {
        return this.apiURI + 'admin/product/' + productId + '/branded-images/' + imageId;
    }

    getProductByCardNum: string = this.apiURI + 'admin/product/card-code/';

    // end Product part

    //order part
    getAllOrders: string = this.apiURI + 'admin/order/list';

    updateOrderStatus(id) {
        return this.apiURI + 'admin/order/' + id + '/status';
    }

    getMembersForOrder: string = this.apiURI + 'admin/members/list';

    createOrder: string = this.apiURI + 'admin/order';

    updateOrder(id) {
        return this.apiURI + 'admin/order/' + id + '/update';
    }

    getOrder(id) {
        return this.apiURI + 'admin/order/' + id;
    }

    getBenefactorList: string = this.apiURI + 'public/settings/benefactors';

    getAddressesList(id) {
        return this.apiURI + 'admin/member/' + id;
    }

    memberAddAddress(id) {
        return this.apiURI + 'admin/member/' + id + '/address';
    }
    //end order part

    //Members
    membersList: string = 'admin/members';
    createMember: string = 'admin/member/create';

    changeMemberStatus(id) {
        return 'admin/member/' + id + '/block'
    }

    getMember(memberId) {
        return 'admin/member/' + memberId;
    }

    updateMember(memberId) {
        return 'admin/member/' + memberId + '/update';
    }

    cancelSubscription(id) {
        return this.apiURI + 'admin/membership_subscription/' + id + '/cancel';
    }

    getMemberAddresses(memberId) {
        return 'admin/member/' + memberId + '/addresses';
    }

    addMemberAddress(memberId) {
        return 'admin/member/' + memberId + '/address';
    }

    deleteMemberAddress(memberId, addressId) {
        return 'admin/member/' + memberId + '/address/' + addressId + '/delete';
    }

    editMemberAddress(memberId, addressId) {
        return 'admin/member/' + memberId + '/address/' + addressId;
    }

    getMemberOrders = 'admin/order/list';
    changeMemberPassword = 'admin/member/change-password';

    listMemberProductCards(memberId) {
        return 'admin/members/' + memberId + '/cards/list';
    }

    setNotesToMember(memberId) {
        return 'admin/member/' + memberId + '/notes';
    }

    addProductCardToMember(memberId) {
        return 'admin/member/' + memberId + '/addcard';
    }

    merchantRedemptionReport: string = 'merchant/report/stats';

    getRedeemStats: string = 'transaction/redeemStats';
    transactionsList: string = 'transaction/list';
    awardsTransactionsList: string = 'award/transaction/list';

    memberStatsReport = 'admin/members/statsReport';

    comparisonReport:string  = this.apiURI + 'merchant/report/comparison';
    filterRedemptions: string = 'admin/members/redemptionsReport';
    exportComparisonReport: string = this.apiURI + 'merchant/report/comparison/export';

    getInternalOrdersReport: string = this.apiURI + 'admin/order/ioreport';
    exportInternalOrder: string = this.apiURI + 'admin/order/report';
    exportPromoCodes: string = this.apiURI + 'admin/promo-codes/report';

    notificationsFilter: string = this.apiURI + 'admin/notifications/filter';
    createNotification: string = this.apiURI + 'admin/notifications/create';
    notificationsList: string = this.apiURI + 'admin/notifications/list';
    createTestNotification: string = this.apiURI + 'admin/notifications/test';
    refreshView: string = this.apiURI + 'admin/refreshview';

    locationFeaturedReport: string = this.apiURI + 'location/featured-report';

    getReportPeriods(merchantId) {
        return this.apiURI + 'merchant/' + merchantId + '/monthly-report/periods';
    }

    getMonthlyReport() {
        return this.apiURI + 'merchant/monthly-report/stats';
    }

    getMerchantAwards(id) {
        return this.apiURI + 'merchant/' + id + '/award/list';
    }

    addNewMerchantAward(merchantId) {
        return this.apiURI + 'merchant/' + merchantId + '/award';
    }

    updateMerchantAward(merchantId, awardId) {
        return this.apiURI + 'merchant/' + merchantId + '/award/' + awardId;
    }

    getAward(merchantId, awardId) {
        return this.apiURI + 'merchant/' + merchantId + '/award/' + awardId;
    }

    updateAwardStatus(merchantId, awardId) {
        return this.apiURI + 'merchant/' + merchantId + '/award/' + awardId + '/enabled';
    }

    getPinsForLocation(locationId) {
        return this.apiURI + 'merchant/location/' + locationId + '/pins';
    }

    duplicateOffer(merchantId, offerId) {
        return this.apiURI + 'merchant/' + merchantId + '/offer/' + offerId + '/autorenew';
    }

    exportMerchantMembers(merchantId) {
        return this.apiURI + 'admin/members/emails/export/' + merchantId;
    }

    getNotification(notificationId) {
        return this.apiURI + 'admin/notifications/' + notificationId;
    }

    updateNotification(notificationId) {
        return this.apiURI + 'admin/notifications/update/' + notificationId;
    }

    updateNotificationStatus(notificationId) {
        return this.apiURI + 'admin/notifications/status/' + notificationId;
    }

    getPromoCodeToken: string = this.apiURI + 'admin/promo-codes/token';
    createPromoCode: string = this.apiURI + 'admin/promo-codes';
    promoCodesList: string = this.apiURI + 'admin/promo-codes/list';

    getPromoCode(promoCodeId) {
        return this.apiURI + 'admin/promo-codes/' + promoCodeId;
    }

    updatePromoCode(promoCodeId) {
        return this.apiURI + 'admin/promo-codes/' + promoCodeId;
    }

    updatePromoCodeStatus(promoCodeId) {
        return this.apiURI + 'admin/promo-codes/' + promoCodeId + '/status';
    }

    getPromoCodeStatistics(promoCodeId) {
        return this.apiURI + 'admin/promo-codes/' + promoCodeId + '/stats';
    }

    createSalesRep: string = this.apiURI + 'admin/sales-rep';
    salesRepList: string = this.apiURI + 'admin/sales-rep/list';

    getSalesRep(salesRepId) {
        return this.apiURI + 'admin/sales-rep' + salesRepId;
    }

    updateSalesRep(salesRepId) {
        return this.apiURI + 'admin/sales-rep/' + salesRepId;
    }

    createBeneficiary: string = this.apiURI + 'admin/beneficiaries';
    beneficiaryList: string = this.apiURI + 'admin/beneficiaries/list';
    importBeneficiaryFile: string = this.apiURI + 'admin/beneficiaries/import';

    getBeneficiary(beneficiaryId) {
        return this.apiURI + 'admin/beneficiaries' + beneficiaryId;
    }

    updateBeneficiary(beneficiaryId) {
        return this.apiURI + 'admin/beneficiaries/' + beneficiaryId;
    }

    getBeneficiaryMembershipsReport(beneficiaryId) {
        return this.apiURI + 'admin/beneficiaries/' + beneficiaryId + '/report';
    }

    getBeneficiaryRedemptionsReport(beneficiaryId) {
        return this.apiURI + 'admin/beneficiaries/' + beneficiaryId + '/report/redemption';
    }

    getOrderPrice: string = this.apiURI + 'admin/order/price';

    marketsList: string = this.apiURI + 'admin/settings/market/list';
    createMarket: string = this.apiURI + 'admin/settings/market';

    createCategory: string = this.apiURI + 'admin/settings/category';

    updateMarket(marketId) {
        return this.apiURI + 'admin/settings/market/' + marketId;
    }

    updateMarketImages(marketId) {
        return this.apiURI + 'admin/settings/market/' + marketId + '/image';
    }

    getMarket(marketId) {
        return this.apiURI + 'admin/settings/market/' + marketId;
    }

    updateCategory(catId) {
        return this.apiURI + 'admin/settings/category/' + catId;
    }

    getCategory(catId) {
        return this.apiURI + 'admin/settings/category/' + catId;
    }

    getTemplatesList(active, type){
        return (this.apiURI + 'admin/template/list?active=' + active + (type != null ? '&type=' + type : ''));
    }

    updateTemplateStatus(templateId) {
        return this.apiURI + 'admin/template/' + templateId + '/toggle';
    }

    deleteTemplateImage(templateId, imageId) {
        return this.apiURI + 'admin/template/' + templateId + '/images/' + imageId;
    }

    getTemplateTypes() {
        return this.apiURI + 'admin/template/types';
    }

    createTemplate() {
        return this.apiURI + 'admin/template';
    }

    getTemplate(templateId) {
        return this.apiURI + 'admin/template/' + templateId;
    }

    updateTemplate(templateId) {
        return this.apiURI + 'admin/template/' + templateId;
    }

    cloneTemplate(templateId) {
        return this.apiURI + 'admin/template/' + templateId + '/clone';
    }

    sendTestEmail(templateId) {
        return this.apiURI + 'admin/template/' + templateId + '/test';
    }

    uploadTemplateImage(templateId) {
        return this.apiURI + 'admin/template/' + templateId + '/image';
    }

    associateWithForeignProducts(upgradeId, targetId) {
        return this.apiURI + 'admin/product/' + upgradeId + '/associate/' + targetId;
    }

    toggleMembershipStatus(userId, membershipId) {
        return this.apiURI + `admin/member/${userId}/membership/${membershipId}/toggle`
    }
}



// WEBPACK FOOTER //
// ./src/app/config/config.service.ts